import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { RadioButton } from 'material-ui/RadioButton';

import { Labeled, translate } from 'admin-on-rest';

export class RadioButtonGroupInput extends Component {
  shouldComponentUpdate = (nextProps) => ((this.props.choices.length < nextProps.choices.length) || (this.props.input.value !== nextProps.input.value));

  handleChange = (value) => {
    this.props.input.onChange(value);
  };

  renderRadioButton = (choice) => {
    const {
      optionText,
      translate, // eslint-disable-line
      translateChoice,
      input,
    } = this.props;
    const choiceName = React.isValidElement(optionText) // eslint-disable-line no-nested-ternary
      ? React.cloneElement(optionText, { record: choice })
      : typeof optionText === 'function'
        ? optionText(choice)
        : get(choice, optionText);

    return (
      <RadioButton
        key={choice._id}
        label={
          translateChoice ? (
            translate(choiceName, { _: choiceName })
          ) : (
            choiceName
          )
        }
        onCheck={(e, value) => this.handleChange(value)}
        checked={choice._id === input.value._id}
        value={choice}
      />
    );
  };

  render() {
    const {
      label,
      resource,
      source,
      isRequired,
      choices,
    } = this.props;

    return (
      <Labeled
        label={label}
        onChange={this.handleChange}
        resource={resource}
        source={source}
        isRequired={isRequired}
      >
        <div>
          {choices.map(this.renderRadioButton)}
        </div>
      </Labeled>
    );
  }
}

RadioButtonGroupInput.propTypes = {
  choices: PropTypes.arrayOf(PropTypes.object),
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  optionText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element,
  ]),
  resource: PropTypes.string,
  source: PropTypes.string,
  translate: PropTypes.func.isRequired,
  translateChoice: PropTypes.bool,
};

RadioButtonGroupInput.defaultProps = {
  choices: [],
  optionText: 'name',
  translateChoice: true,
};

export default translate(RadioButtonGroupInput);
